import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { extendSession, logout } from '../redux/slices/authSlice';
import { clearCampData } from '../redux/slices/campSlice';
import { clearCenter } from '../redux/slices/centerSlice';
import { clearCenters } from '../redux/slices/centersListSlice';
import { clearYkVisitData } from '../redux/slices/ykVisitSlice';
import { useNavigate } from 'react-router-dom';

const SessionExtender = ({ onExtend, onLogout }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isExtending, setIsExtending] = useState(false);

  const handleExtendSession = () => {
    setIsExtending(true);
    dispatch(extendSession());
    setTimeout(() => {
      setIsExtending(false);
      if (onExtend) onExtend();
    }, 500);
  };

  const handleLogout = () => {
    dispatch(logout());
    dispatch(clearCampData());
    dispatch(clearCenter());
    dispatch(clearCenters());
    dispatch(clearYkVisitData());
    sessionStorage.removeItem('yk_camp_centers_cache');
    sessionStorage.removeItem('yk_class_centers_cache');
    if (onLogout) onLogout();
    navigate('/');
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center p-4 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 animate-slideInUp">
        {/* Warning Icon */}
        <div className="flex justify-center mb-6">
          <div className="bg-amber-100 rounded-full p-4">
            <svg
              className="w-12 h-12 text-amber-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">
            Session About to Expire
          </h2>
          <p className="text-gray-600 text-sm">
            Your session will expire soon due to inactivity. Would you like to extend your session?
          </p>
        </div>

        {/* Timer Info */}
        <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-4 mb-6">
          <p className="text-center text-amber-800 font-semibold">
            Your session will expire in 1 minute
          </p>
        </div>

        {/* Buttons */}
        <div className="flex gap-3">
          <button
            onClick={handleExtendSession}
            disabled={isExtending}
            className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-bold py-3 px-6 rounded-full transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isExtending ? (
              <span className="flex items-center justify-center gap-2">
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                Extending...
              </span>
            ) : (
              'Extend Session'
            )}
          </button>
          <button
            onClick={handleLogout}
            disabled={isExtending}
            className="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-full transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Logout
          </button>
        </div>

        {/* Info Text */}
        <p className="text-center text-xs text-gray-500 mt-4">
          Click "Extend Session" to continue for another 20 minutes
        </p>
      </div>
    </div>
  );
};

export default SessionExtender;
